module.exports = __webpack_public_path__ + "img/account-locked.2525734f.png";